import React, { useState } from "react";
import { ArrowRight, Loader2, UserPlus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";

// Support Agent refused an out-of-scope task: one click re-sends the same message to the user's own assistant (or starts creating one).
export function SupportRedirectCard({ m }) {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const text = m.redirect?.text || "";
  const go = async () => {
    setBusy(true);
    try {
      const t = await api.get("/support/redirect-target");
      const persona = t.data?.persona;
      if (!persona) {
        sessionStorage.setItem("aivora_prefill", text);
        toast.message("Buat asisten dulu — pesan Anda disimpan sebagai permintaan pertama");
        nav("/personas/new");
        return;
      }
      const c = await api.post("/conversations/direct", { persona_id: persona.id });
      sessionStorage.setItem("aivora_autosend", JSON.stringify({ cid: c.data.id, text }));
      nav(`/chat/${c.data.id}`);
    } catch (err) { toast.error(err?.response?.data?.detail || "Gagal membuka asisten Anda"); } finally { setBusy(false); }
  };
  const hasAssistant = m.redirect?.has_assistant !== false;
  return (
    <div className="mt-2 rounded-2xl border border-[#D9E2F2] bg-[#F5F8FF] p-3" data-testid="support-redirect-card">
      <p className="text-xs text-slate-500">Pesan yang akan diteruskan:</p>
      <p className="mt-0.5 line-clamp-3 text-sm italic text-slate-700" data-testid="support-redirect-text">“{text}”</p>
      <button onClick={go} disabled={busy} data-testid="support-redirect-btn"
        className="mt-2.5 flex w-full items-center justify-center gap-2 rounded-xl bg-[#2F6BFF] py-2.5 text-sm font-semibold text-white transition hover:bg-[#2558D6] disabled:opacity-60">
        {busy ? <Loader2 size={15} className="animate-spin" /> : hasAssistant ? <ArrowRight size={15} /> : <UserPlus size={15} />}
        {hasAssistant ? "Lanjutkan dengan asisten Anda" : "Buat asisten"}
      </button>
    </div>
  );
}
